import { render, staticRenderFns } from "./OptionExercise.vue?vue&type=template&id=dcab319e&"
import script from "./OptionExercise.vue?vue&type=script&lang=ts&"
export * from "./OptionExercise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports